import { render, staticRenderFns } from "./RequiredInfoForDeli.vue?vue&type=template&id=29b41632&scoped=true&"
import script from "./RequiredInfoForDeli.vue?vue&type=script&lang=js&"
export * from "./RequiredInfoForDeli.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b41632",
  null
  
)

export default component.exports